module.exports = __webpack_public_path__ + "static/media/taskUnio.1415c768.svg";